import styled from 'styled-components';

export const StyledNightThemeGradient = styled.div`
	position: absolute;
	width: 100%;
	height: 120vh;
	background: ${props => props.theme.theming.nightThemeGradient};
	opacity: ${props => props.theme.theming.nightThemeGradientOpacity};
	transition: opacity ${props => props.theme.theming.nightDayTransitionDuration} ease;
	pointer-events: none;
	z-index: -1;
`;
